export default {"src":"/_next/static/media/phone.063f0cf1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};